enum ButtonSize {
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
}

enum ButtonVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  ERROR = "error",
  OUTLINE = "outline",
  GHOST = "ghost",
}
interface ButtonProps {
  text: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  size?: ButtonSize;
  variant?: ButtonVariant;
  disabled?: boolean;
  testID?: string;
  type?: "button" | "submit";
  ariaLabel?: string;
}

export { ButtonSize, ButtonVariant };
export type { ButtonProps };
